export const routes = (parentName) => {
  return [
    {
      path: "tickets",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Tickets`,
          component: () => import("./List.vue"),
          props: (route) => ({
            status: route.query.status,
          }),
        },
        {
          path: ":id",
          name: `${parentName}-Tickets-View`,
          component: () => import("./View.vue"),
        },
      ],
    },
  ];
};
